/**
 * 来款登记
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/5/17      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import Lang from "@components/Lang/Lang";
import {Form,DatePicker, Input,Button,Row,Col,Select,message,Spin} from "antd";
import UploadFileIcon  from '@components/UploadFile/UploadImage/UploadFileIcon';
import EssaModal from "@/components/EssaModal/EssaModal";
import {splitNumber,isEmpty} from '@utils/utils';
import "./index.less";
// import BuyerSelector from "../BuyerSelector";
import SearchSelector from '@components/SearchSelector/SearchSelector';
import { toFixedWithCommas} from "@utils/number-util";
import Cookie from "../../../../../utils/cookie";
import _ from 'lodash';
import Locale from "../../../../../utils/locale";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
let locale = Locale.current();
const { TextArea } = Input;
const { Option } = Select;

dayjs.extend(customParseFormat);


class Add extends React.Component{
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.state = {
            submitLoading:false,
            valueMoneyIn: '',
            strMoneyIn: '',
            size:'large',
            visible:false,
            valuesForm:{},
            checkSureInfo:{},
            isCheck:1,
            focusNumber:false,
            hasPermission:2,//未设置
            loading:false,
        }
        let extra = Cookie.getJSON("fmg.extra") || {};
        this.params = {
            payTypeList:[],
            //是否触发验证
            isTriggerVerify:false,
            currencySymbol:extra.currencySymbol||"'"
        }
        this.handleOk = _.throttle(this.handleOk, 10000, { leading: true, trailing: false });  //点击触发一次，至少需要在设置的10秒后才能重新触发
        let payTypeList = __getDictList('fin_remittance_item_pay_type');
        payTypeList.map( (item)=> {
            if(item.code=='BANK_TRANSFER'||item.code=='CASH'){
                this.params.payTypeList.push(item)
            }
        });
    }

    /**
     * 二次确认
     */
    onCheck=()=> {
        this.params.isTriggerVerify = true;
        const { validateFields } = this.formRef.current;
        validateFields()
            .then((values) => {
                const checkedItem = this.onRefFormSearchRef.getSelectedItem();
                values.buyerCode = checkedItem.buyerCode;
                this.flagShowModal(true,values)
            }).catch((errorInfo) => {});
    };
    flagShowModal(flag=false,values={}){
        this.setState({
            visible: flag,
            submitLoading:flag,
            valuesForm:values,
            checkSureInfo:{},
            isCheck:1,
        })
    }
    /**
     * checkSureInfo.type == ‘1’ 即上一次是需要校验的数据，此次取反
     * */
    handleOk(values){
        const {isCheck,currencySymbol,countryCode } = this.state;
        let moneyInTime = (values.moneyInTime).format('YYYY/MM/DD');
        moneyInTime = dayjs(moneyInTime + ' 23:59:59').valueOf();
        this.loading(true);
        $.ajax({
            url: "/service/mg/fin/ddp/remittance-item/save",
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify({
                bankSeq:values.bankSeq,
                buyerId:values.buyerId,
                attachmentVOs:values.attachmentVOs||[],
                moneyIn: Number(values.moneyIn),
                moneyInTime:dayjs(moneyInTime).valueOf(),
                payType:values.payType,
                remark:values.remark,
                isCheck:isCheck,
                currencySymbol:currencySymbol,
                countryCode:countryCode
            }),
            success:(res)=>{
                this.params.isTriggerVerify = false;
                this.loading(false);
                if(res.success&&res.valid){
                    message.success(__getServerLanguage('TiJiaoChengGong'))
                    this.flagShowModal();//关闭
                    //清空表单
                    this.params.isTriggerVerify = false;
                    this.formRef.current.resetFields();
                    this.onChangeRow({});//清空选择
                    //成功 清空相关校验
                    this.setState({
                        valueMoneyIn: '',
                        strMoneyIn: '',
                    })
                    //回调
                    if(typeof this.props.callBack == 'function'){
                        this.props.callBack();
                    }

                }else if(!res.valid && res.model){
                    const checkSureInfo = res.model;
                    this.setState({
                        checkSureInfo:checkSureInfo,
                        isCheck:0
                    })
                }
            },error:()=>{
                this.loading(false);
                this.setState({
                    submitLoading:false
                });
            }
        });
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 修改数字
     */
    changeNumber(e){
        let { value } = e.target;
        const { setFieldsValue } = this.formRef.current;
        if(!isEmpty(value)){
            value = value.replace(/[^\d.]/g, "");  //清除“数字”和“.”以外的字符
            value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
            value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');//只能输入两个小数
        }
        setFieldsValue({
            moneyIn: value
        });
        this.setState({
            valueMoneyIn: value,
            strMoneyIn: value.replace(/\d{1,3}(?=(\d{3})+(\.|$))/g,'$& ').replace('.',',')
        })
    }
    changeNumberFocus(flag=true){
        this.setState({
            focusNumber :flag
        })
    }
    onRefFormSearch = (ref) =>  this.onRefFormSearchRef = ref;
    // 选择客户后回调行数据
    onChangeRow(dat={}){
        this.setState({
            countryName: dat.countryName,
            currencySymbol:dat.currencySymbol,
            hasPermission:isEmpty(dat.hasPermission)?2:dat.hasPermission,// 为2 时 无操作或清空选择
            countryCode:dat.countryCode
        })
    }
    render(){
        const {submitLoading,valueMoneyIn,loading, strMoneyIn,size,visible,valuesForm,checkSureInfo,focusNumber,countryName,currencySymbol,hasPermission} = this.state;
        let layout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            labelAlign:"left"
        };
        if(locale!='zh'){
            layout = {
                labelCol: { span: 7 },
                wrapperCol: { span: 17 },
                labelAlign:"left"
            };
        }
        const dateFormat = 'YYYY/MM/DD';
        return (<Spin spinning={loading}>
            <div className="payment-check-in-add-wrap">
                <Form
                    ref={this.formRef}
                    {...layout}
                    // initialValues={{ moneyInTime: dayjs(dayCurrent, 'YYYY-MM-DD') }}
                    name="basic"
                >
                    <Form.Item
                        label={__getServerLanguage('KeHu')}
                        name="buyerId"
                        rules={[{ required: true, message: __getServerLanguage('QingShuRuKeHuBianMa') }]}
                    >
                        {/*<BuyerSelector size={size} callBack={this.BuyerSelectorCallBack}></BuyerSelector> 复制客户名赋值时有BUG不建议使用 */}
                        <SearchSelector size={size}
                                        onRef={this.onRefFormSearch}
                                        onChangeRow={(dat)=>this.onChangeRow(dat)}
                                        title= {Lang({id: "KeHu",default: "客户",})}
                                        searchField={'keyWord'}
                                        api={'/service/mg/fin/ddp/remittance-item/buyerList'}
                                        field = {[
                                            { cnTitle: '客户编号',cnTitleId:'KeHuBianHao', dataIndex:'buyerCode'},
                                            { cnTitle: '客户名称',cnTitleId:'KeHuMingCheng', dataIndex:'buyerName'},
                                            { title: 'ID',dataIndex:'buyerId'},
                                            { cnTitle: '所属国家',cnTitleId:'SuoShuGuoJia',dataIndex:'countryName'},
                                            { cnTitle: '交易货币',cnTitleId:'JiaoYiHuoBi',dataIndex:'currencySymbol'},
                                        ]}
                                        idField={'buyerId'} />
                    </Form.Item>
                    <Form.Item
                        label={__getServerLanguage('DaoKuanRiQi')}
                        name="moneyInTime"
                        initialValue={dayjs()}
                        rules={[{ required: true, message: __getServerLanguage('QingXuanZeDaoKuanRiQi') }]}
                    >
                        <DatePicker size={size} placeholder={__getServerLanguage('QingXuanZeDaoKuanRiQi')} format="YYYY-MM-DD" />
                    </Form.Item>
                    <Form.Item
                        label={__getServerLanguage('YinHangLiuShuiHao')}
                        name="bankSeq"
                    >
                        <Input maxLength={100} size={size} placeholder={__getServerLanguage('QingShuRuYinHangLiuShuiHao')}/>
                    </Form.Item>
                    <Form.Item
                        label={__getServerLanguage('FuKuanFangShi')}
                        name="payType"
                        rules={[{ required: true, message: __getServerLanguage('QingXuanZeFuKuanFangShi') }]}
                    >
                        <Select size={size} placeholder={__getServerLanguage('QingXuanZeFuKuanFangShi')}>
                            {this.params.payTypeList.map(function (item,index) {
                                return <Option key={index} value={item.code}>{item.name}</Option>
                            })}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label={Lang({id:"KeHuQianBao",default:"客户钱包"})}
                        name="countryName"
                    >
                        <p className={`black66${!countryName&&hasPermission!=2?" color-err":""}`}>
                            {Lang({id:"KeHuDangQianQianBaoSuoShuGuoJia",default:"客户当前钱包所属国家"})}
                            <span className={"ml_6"}>{!countryName&&hasPermission!=2?Lang({id:"ZanMeiQueRen",default:"暂没确认"}):countryName}</span>
                        </p>
                    </Form.Item>
                    <Form.Item
                        label={__getServerLanguage('DaoZhangJinE')}
                        name="moneyIn"
                        rules={[
                            {required: true, message: __getServerLanguage('QingShuRuDaoZhangJinE') }
                        ]}
                        className={"bold_input"}
                    >
                        <Input id='rerer' size={size} maxLength={10}
                               onChange={this.changeNumber.bind(this)}
                               onFocus = {()=>this.changeNumberFocus(true)}
                               onBlur  = {()=>this.changeNumberFocus(false)}
                               value={valueMoneyIn}
                               addonBefore={<span>{currencySymbol}</span>}
                               placeholder={__getServerLanguage('QingShuRuDaoZhangJinE')}/>
                        {strMoneyIn&&<div className={"popup-moq-tips"} style={focusNumber?{display:'block'}:{}}>{strMoneyIn}</div>}
                    </Form.Item>
                    <Form.Item
                        label={Lang({id:"ShuiDan",default:"水单"})}//
                        name="attachmentVOs"
                        rules={[
                            {required: false, message: __getServerLanguage('ShangChuanShuiDanXinXi') }
                        ]}
                        // className={"bold_input"}
                    >
                        <UploadFileIcon accept={'.pdf, .jpg, jpeg, .png, .gif, .bmp'}
                                        key={"attachmentVOs"}
                                        maxCount={999}
                                        fileSizeLimit={10*1024*1024}/>
                    </Form.Item>
                    <Form.Item
                        label={__getServerLanguage('BeiZhu')}
                        name="remark">
                        <TextArea size={size} autoSize={{ minRows: 4, maxRows: 4 }} maxLength={600} placeholder={__getServerLanguage('QingShuRuBeiZhuXinXi')}/>
                    </Form.Item>
                    <Row>
                        <Col offset={layout.labelCol.span} span={layout.wrapperCol.span}>
                            <Button size={size} loading={submitLoading} onClick={this.onCheck}
                                    disabled={hasPermission==0}
                                    type="primary" shape="round">
                                {hasPermission==0?Lang({id:"WuQuanXian",default:"无权限"}):__getServerLanguage('XinZeng')}</Button>
                        </Col>
                    </Row>
                </Form>
                {visible&&<EssaModal title={Lang({id: "TiShi",default: "提示"})}
                                     open={visible}
                                     width={600}
                                     onOk={()=>this.handleOk(valuesForm)}
                                     onCancel={()=>this.flagShowModal(false)}>
                    <Spin spinning={loading}>
                        {checkSureInfo&&checkSureInfo.buyerCode?<div>
                            <p className={"font_18 font-main"} dangerouslySetInnerHTML={{ __html: __getServerLanguage('KeHuZaiDengJiLeiTongYangDeJinE',`<span class="ml_4 mr_4">${checkSureInfo.buyerCode}</span>`,
                                    `<span class="ml_4 mr_4">${checkSureInfo.time?dayjs(checkSureInfo.time).format("YYYY-MM-DD HH:mm:ss"):''}</span>`,
                                    `<span class="ml_4 mr_4">${strMoneyIn}</span><span>${currencySymbol}</span>`) }}>
                            </p>
                            <p className={"font_14 font-title"}>{Lang({id: "ShiFouJiXuDengJi",default: "是否继续登记"})}?</p>
                        </div>:<div>
                            <p className={"font_14"}>{__getServerLanguage('QingQueRenLuRuDeDaoZhangJinEShiFouZhengQue')}</p>
                            <div className={"pop_tips_sure_grey mt_8"}>
                                <div className={"font_24"}>{valuesForm.buyerCode||'-'}</div>
                                <div className={"font_36 p-title"}><span className={"plus_icon mr_12"}>+</span>{strMoneyIn}<span className={"ml_12"}>{currencySymbol}</span></div>
                            </div>
                        </div>}
                    </Spin>
                </EssaModal>}
            </div>
        </Spin>)
    }
}

Add.defaultProps = {
    callBack:function () {

    }
}

export default Add;
